import type { Record } from "~/tools/record";

export const {
	VITE_PRODUCT_NAME: PRODUCT_NAME,
	VITE_CONTENTFUL_SPACE_ID: CONTENTFUL_SPACE_ID,
	VITE_CONTENTFUL_ACCESS_TOKEN: CONTENTFUL_ACCESS_TOKEN,
	VITE_BUILD_DATE: BUILD_DATE,
} = import.meta.env as Record<string, string>;
